import { Text } from '@chakra-ui/react'

export const ValidationErrorText = ({ text }: { text: string }) => {
  return (
    <Text fontSize="16px" color="brand.text.alert" marginTop="2px">
      {text}
    </Text>
  )
}
